import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { EmailClicked, TwitterButtonAnalytics } from '../../../utils/Analytics.js';
import SocialButton from './SocialButton.jsx';

const url = window.location.href;

class EmailButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageSrc: null
        };

        this.url = this.props.profileUrl
    }

    render() {
        const color = this.props.color;
        return (
            <SocialButton
                imageSrc='https://cdn.obsess-vr.com/ferragamo/envelope_outline.svg'
                style={this.props.style}
                redirectUrl={this.url}
                color={color}
                onClickAnalytics={EmailClicked}
            />
        );
    }
}

EmailButton.propTypes = {
    style: PropTypes.object
};

export default EmailButton;
